import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import LazyImage from './LazyImage';
import { useCurrency } from '../contexts/CurrencyContext';

const API = `${window.location.origin}/api`;

export default function CustomersAlsoBought({ productId }) {
  const { formatPrice } = useCurrency();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!productId) return;
    setLoading(true);
    axios.get(`${API}/products/${productId}/related?limit=8`)
      .then(res => setItems(res.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [productId]);

  if (loading) {
    return (
      <section className="mt-16">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-8 h-[1px] bg-[#D4AF37]" />
          <h3 className="text-sm uppercase tracking-[0.2em] text-[#D4AF37] font-sans font-medium">Customers Also Bought</h3>
          <div className="flex-1 h-[1px] bg-[#D4AF37]/20" />
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="animate-pulse">
              <div className="bg-[#141414] aspect-square mb-2" />
              <div className="h-3 bg-[#141414] w-2/3 mb-1" />
              <div className="h-3 bg-[#141414] w-1/3" />
            </div>
          ))}
        </div>
      </section>
    );
  }
  if (!items.length) return null;

  return (
    <section className="mt-16" data-testid="customers-also-bought">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-8 h-[1px] bg-[#D4AF37]" />
        <h3 className="text-sm uppercase tracking-[0.2em] text-[#D4AF37] font-sans font-medium">Customers Also Bought</h3>
        <div className="flex-1 h-[1px] bg-[#D4AF37]/20" />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {items.map(p => (
          <Link
            key={p.id}
            to={`/product/${p.id}`}
            className="group block"
            data-testid={`also-bought-${p.id}`}
          >
            <div className="aspect-square overflow-hidden border border-white/5 group-hover:border-[#D4AF37]/40 transition-colors mb-2 relative">
              <LazyImage src={p.image_url} alt={p.name} className="w-full h-full group-hover:scale-105 transition-transform duration-500" />
              {p.stock > 0 && p.stock < 5 && (
                <span className="absolute top-2 left-2 bg-[#F59E0B] text-black text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5">
                  Only {p.stock} left
                </span>
              )}
            </div>
            <p className="text-white text-xs sm:text-sm font-sans group-hover:text-[#D4AF37] transition-colors truncate">{p.name}</p>
            <p className="text-[#D4AF37] text-xs font-sans mt-0.5">{formatPrice(p.base_price)}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
